import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

const GuestToolbar = () => {
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
    const [language, setLanguage] = useState('English'); // State for selected language

    // Function to handle showing the modal
    const handleShowModal = () => setShowModal(true);

    // Function to handle closing the modal
    const handleCloseModal = () => setShowModal(false);

    // Function to trigger Google Translate
    const translatePage = (lang) => {
        if (lang === 'Bangla') {
            const googleTranslateElement = document.querySelector('.goog-te-combo');
            if (googleTranslateElement) {
                googleTranslateElement.value = 'bn'; // Set the language to Bangla
                googleTranslateElement.dispatchEvent(new Event('change')); // Trigger change event
            }
        } else {
            const googleTranslateElement = document.querySelector('.goog-te-combo');
            if (googleTranslateElement) {
                googleTranslateElement.value = 'en'; // Set the language to English (default)
                googleTranslateElement.dispatchEvent(new Event('change')); // Trigger change event
            }
        }
        setLanguage(lang); // Set the current language
        handleCloseModal(); // Close the modal
    };

    return (
        <div className="footer-menu showShadow">
        <div className="footer-wrap">
          <div className="language-container">
            <div onClick={handleShowModal} className="lang-select">
              <img className="language-icon" src="https://images.3953049.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg" alt="" />
              <span className="language-name">{language === 'Bangla' ? 'BDT বাংলা' : 'BDT English'}</span>
              <svg className="am-icon am-icon-arrow-down_cee2e8d6 am-icon-md arrow">
                <use xlinkHref="#arrow-down_cee2e8d6" /></svg>
            </div>
          </div>
          <div className="footer-login"><Link to={'/login'} style={{color: '#fff'}}>Login</Link></div>
          <div className="footer-register"><Link to={'/signup'} style={{color: '#333'}}>Register</Link></div>
        </div>
        <Modal className='language-container' show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Choose Language</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="language-btn-wrap">
                    <div className="current-language">
                      <img
                        className="current-icon"
                        src="https://images.3953049.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg"
                        alt=""
                      />
                      <div className="currencySymbol">৳</div>
                      <div className="countryName">BDT</div>
                    </div>
                    <div onClick={() => translatePage('Bangla')} className="language-btn-group">
                      <div className={`language-item ${language === 'Bangla' ? 'language-active' : ''} `}>
                        <span className="language-name">বাংলা</span>
                      </div>
                    </div>
                    <div onClick={() => translatePage('English')} className="language-btn-group">
                      <div className={`language-item ${language === 'English' ? 'language-active' : ''} `}>
                        <span className="language-name">English</span>
                      </div>
                    </div>
                  </div>

                </Modal.Body>
            </Modal>
      </div>
      
    );
};

export default GuestToolbar;
